import { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import {
  trackBuyNowTapped,
  trackAddToCart,
} from "../../actions/TrackingActions";

// Constants
import { EVENT_PROPERTIES_VALUES } from "../../types/Amplitude";

/**
 * TODO: Clean up/Rename
 * - Generic TrackedCta component name, but has context-specific tracking action
 *   that is hardcoded here for the Rest Buy Now button
 * - No way to add multiple tracking actions if needed
 * - Might be better to have a single Tracking compound component w/ all tracking actions present
 */

export class TrackedCta extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    trackAddToCart: PropTypes.func.isRequired,
    trackBuyNowTapped: PropTypes.func.isRequired,
    render: PropTypes.func.isRequired,
    productName: PropTypes.oneOf([
      EVENT_PROPERTIES_VALUES.Rest,
      EVENT_PROPERTIES_VALUES.Rest_Plus,
      EVENT_PROPERTIES_VALUES.Grow,
      EVENT_PROPERTIES_VALUES.Listen,
      EVENT_PROPERTIES_VALUES.Membership,
    ]).isRequired,
    buttonText: PropTypes.oneOf([
      EVENT_PROPERTIES_VALUES.Join_Now,
      EVENT_PROPERTIES_VALUES.Buy_Now,
      EVENT_PROPERTIES_VALUES.Buy_On_Amazon,
      EVENT_PROPERTIES_VALUES.Learn_More,
    ]).isRequired,
    sectionName: PropTypes.oneOf([
      EVENT_PROPERTIES_VALUES.Product_Details,
      EVENT_PROPERTIES_VALUES.Buy_Box,
      EVENT_PROPERTIES_VALUES.Hero,
      EVENT_PROPERTIES_VALUES.Comparison_Chart,
    ]).isRequired,
    pageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      trackOnClick: this.trackOnClick,
    };
  }

  trackOnClick = async () => {
    const { variant } = queryString.parse(this.props.location.search);
    await this.props.trackAddToCart({
      product: this.props.productName,
    });

    this.props.trackBuyNowTapped({
      product: this.props.productName,
      buttonText: this.props.buttonText,
      sectionName: this.props.sectionName,
      pageName: this.props.pageName,
      pageUrl: this.props.location.pathname,
      pageVariant: variant,
    });
  };

  render() {
    return this.props.render(this.state);
  }
}

const mapDispatchToPackagesButtonProps = (dispatch) => {
  return {
    trackAddToCart: ({ product }) => dispatch(trackAddToCart({ product })),
    trackBuyNowTapped: ({
      product,
      sectionName,
      buttonText,
      pageName,
      pageUrl,
      pageVariant,
    }) =>
      dispatch(
        trackBuyNowTapped({
          product,
          sectionName,
          buttonText,
          pageName,
          pageUrl,
          pageVariant,
        })
      ),
  };
};

export default withRouter(
  connect(null, mapDispatchToPackagesButtonProps)(TrackedCta)
);
